/**
 * Created by Ning Jiang on 2024-05-29.
 */

import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {DeadwoodRipLayers, Layers} from "./DeadwoodRipLayers";
import {DeadwoodRip} from "../DeadwoodRip";
import {DeadwoodRipReelView} from "../reels/DeadwoodRipReelView";

export class NearWinView {

    private _spine:PIXI.spine.Spine | null;
    private _layer:StageLayer;

    constructor() {
        this._layer = DeadwoodRipLayers.getLayer(Layers.NEAR_WIN)!;
    }

    public stopNearWin():void {
        if(this._spine) {
            this._spine.state.setEmptyAnimations(0);
            if(this._spine.parent) {
                this._spine.parent.removeChild(this._spine);
            }
            this._spine.destroy();
            this._spine = null;
        }
    }

    public playScatterNearWin(reelId:number):void {
        if(!this._spine) {
            this._spine = new PIXI.spine.Spine(DeadwoodRip.assetLoader.getSpineAsset(`nearWin`));
            this._spine.autoUpdate = true;
        }
        this._spine.position.set(DeadwoodRipReelView.REEL_AREAS[reelId].x, 360);
        this._layer.addChild(this._spine);
        this._spine.state.setAnimation(0, `reel${reelId + 1}Scatter`, true);
    }

    public playBigWinNearWin():void {
        if(!this._spine) {
            this._spine = new PIXI.spine.Spine(DeadwoodRip.assetLoader.getSpineAsset(`nearWin`));
            this._spine.autoUpdate = true;
        }
        this._spine.position.set(DeadwoodRipReelView.REEL_AREAS[4].x, 360);
        this._layer.addChild(this._spine);
        this._spine.state.setAnimation(0, `reel5bigwin`, true);
    }
}